export enum CreditCardBrands {
  VISA = 'visa',
  MASTERCARD = 'mastercard',
}
